import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.423 1.57c.2.008.39.095.527.243l2.742 2.967a.76.76 0 0 1-.042 1.07l-9.642 8.914a.76.76 0 0 1-.352.183l-3.904.858a.758.758 0 0 1-.887-.96l1.16-3.825a.76.76 0 0 1 .211-.336l9.643-8.913a.76.76 0 0 1 .544-.201m-.072 1.828-8.935 8.26-.726 2.39 2.44-.536 8.935-8.26zM1.667 17.673c0-.418.339-.758.757-.758h15.152a.758.758 0 0 1 0 1.516H2.424a.76.76 0 0 1-.757-.758",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }